import { PaletteOptions } from "@mui/material";

export const palette: PaletteOptions = {
  //color names taken from toolkit

  background: {
    default: "#1b1b1b",
  },

  text: {
    primary: "#ffffff",
    secondary: "#808080",
  },

  primary: {
    main: "#5C61FF",
    light: "#ffffff",
    dark: "#5C61FF",
  },
  secondary: {
    main: "#A057FF",
    light: "#F8F8F8",
    dark: "#707070",
  },
  success: {
    main: "#007E4E",
    light: "#0BBC7833",
  },
  error: {
    main: "#E24E4E",
    light: "#CA001B33",
  },

  //custom
  dark: {
    primary: "#1b1b1b",
    secondary: "rgba(0, 0, 0, 0.85)",
    tertiary: "#000000",
  },

  gradient: {
    primary: "linear-gradient(90deg, #9366FF 0%, #5C61FF 100%)",
  },

  tagBorder: {
    primary: "transparent",
  },
};
